<template>
    <section class="section header-landing-section white">
        <div class="container">
            <p class="title is-spaced">{{ t('meclee-ui.landings.business.investment.title') }}</p>
            <p>{{ t('meclee-ui.landings.business.investment.intro') }}</p>

            <h2 class="text-subtitle">{{ t('meclee-ui.landings.business.investment.corporate.title') }}</h2>
            <p>{{ t(`meclee-ui.landings.business.investment.corporate.text1`) }}</p>
            <ul class="is-stylized" style="margin: 20px 10px;">
                <li v-for="(n, i) in 3" :key="`landings.business.investment.corporate.items-${i}`">
                  {{ t(`meclee-ui.landings.business.investment.corporate.items.${i}`) }}
                </li>
            </ul>
            <p>{{ t(`meclee-ui.landings.business.investment.corporate.text2`) }}</p>

            <h2 class="text-subtitle">{{ t('meclee-ui.landings.business.investment.why.title') }}</h2>
            <p>{{ t(`meclee-ui.landings.business.investment.why.text1`) }}</p>
            <ul class="is-stylized" style="margin: 20px 10px;">
                <li v-for="(n, i) in 4" :key="`landings.business.investment.why-${i}`">
                  {{ t(`meclee-ui.landings.business.investment.why.items.${i}`) }}
                </li>
            </ul>
            <p>{{ t(`meclee-ui.landings.business.investment.why.text2`) }}</p>
        </div>
    </section>
</template>
<script setup>
const { t } = useI18n();
</script>
